'use client';

import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { WebSocketContext } from '@/providers';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { UserType } from '@/types/user';
import { cn } from '@/lib/utils';
type UserAvatarProps = {
  user: Pick<UserType, 'id' | 'firstname' | 'lastname' | 'online'>;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showOnlineStatus?: boolean;
};
const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16'
};
const indicatorSizes = {
  sm: 'h-2.5 w-2.5',
  md: 'h-3 w-3',
  lg: 'h-4 w-4'
};
const textSizes = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg'
};
const UserAvatar = t0 => {
  const $ = _c(25);
  const {
    user,
    size: t1,
    className,
    showOnlineStatus: t2
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const showOnlineStatus = t2 === undefined ? true : t2;
  const context = useContext(WebSocketContext);
  let t3;
  if ($[0] !== context?.userStatuses) {
    t3 = context?.userStatuses ?? {};
    $[0] = context?.userStatuses;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const userStatuses = t3;
  const isOnline = userStatuses[user.id] !== undefined ? userStatuses[user.id] : user.online;
  let t4;
  if ($[2] !== className) {
    t4 = cn("relative", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = sizeClasses[size];
  const t6 = textSizes[size];
  let t7;
  if ($[4] !== t6) {
    t7 = cn("font-semibold", t6);
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== user.firstname) {
    t8 = user.firstname.charAt(0);
    $[6] = user.firstname;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== user.lastname) {
    t9 = user.lastname.charAt(0);
    $[8] = user.lastname;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t10 = <AvatarFallback className={t7}>{t8}{t9}</AvatarFallback>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t5) {
    t11 = <Avatar className={t5}>{t10}</Avatar>;
    $[14] = t10;
    $[15] = t5;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== isOnline || $[18] !== showOnlineStatus || $[19] !== size) {
    t12 = showOnlineStatus && <span className={cn("absolute right-0 bottom-0 rounded-full border-2 border-white dark:border-gray-800", indicatorSizes[size], isOnline ? "bg-green-500" : "bg-gray-500")} />;
    $[17] = isOnline;
    $[18] = showOnlineStatus;
    $[19] = size;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12 || $[23] !== t4) {
    t13 = <div className={t4}>{t11}{t12}</div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t4;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export default UserAvatar;